// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

export type Site = {
  name: string;
  address: string;
  driverCount: number;
};

export type Material = {
  name: string;
  deliverySiteName: string;
};

export type EmissionAdminOperatorMyPageItem = {
  name: string;
  price: string;
  co2Factor: string;
  recycleMethodName: string;
};

export type EmissionAdminSiteMyPageItem = {
  name: string;
  recycleMethodName: string;
  price: string;
  collectionSite: string;
  co2Factor: string;
};

export type EmissionAdminSiteMyPage = {
  operatorName: string;
  siteName: string;
  address: string;
  staffName: string;
  contactEmails: string[];
  tel: string;
  invoiceEmails: string[];
  items: EmissionAdminSiteMyPageItem[];
};

export type EmissionAdminSiteMyPageFormData = {
  staffName?: string;
  contactEmails?: string[];
  tel?: string;
  invoiceEmails?: string[];
};

export type EmissionAdminOperatorMyPage = {
  operatorName: string;
  staffName: string;
  staffEmail: string;
  tel: string;
  address: string;
  siteCount: number;
  items: EmissionAdminOperatorMyPageItem[];
};

export type EmissionAdminOperatorMyPageFormData = {
  staffName?: string;
  tel?: string;
};

export type CollectionAdminOperatorMyPageFormData = {
  staffEmail?: string;
  tel?: string;
};

export type CollectAdminSiteMyPageFormData = {
  enableEmailNotification?: boolean;
  emails?: string[];
};

export type Stations = {
  name: string;
  siteCount: number;
};

export type CollectionAdminOperatorMyPage = {
  operatorName: string;
  address: string;
  staffEmail: string;
  tel: string;
  siteCount: number;
  driverCount: number;
  sites: Site[];
  materials: Material[];
};

export type CollectionUserNormalMyPageFormData = {
  email?: string;
  tel?: string;
};

export type CollectionUserNormalMyPage = {
  email: string;
  operatorName: string;
  siteName: string;
  tel: string;
};

export type CollectionAdminSiteMyPage = {
  siteName: string;
  driverCount: number;
  enableEmailNotification: boolean;
  emails: string[];
  materials: Material[];
};

export type AdminPoolMyPage = {
  mail: string;
  tel: string;
  stations: Stations[];
};

export type CompressionRecycleAdminOperatorMyPageFormData = {
  staffEmail?: string;
  tel?: string;
};

export type CompressionRecycleAdminOperatorMyPage = {
  address: string;
  operatorName: string;
  siteCount: number;
  staffEmail: string | null;
  staffName: string | null;
  tel: string | null;
};

export type RecycleAdminOperatorMyPageFormData = {
  staffEmail?: string;
  tel?: string;
};

export type RecycleAdminOperatorMyPage = {
  address: string;
  operatorName: string;
  siteCount: number;
  staffEmail: string | null;
  staffName: string | null;
  tel: string | null;
};

export enum MyPageType {
  CollectionAdminOperator = 'collectionAdminOperator',
  CollectionUserNormal = 'collectionUserNormal',
  CollectionAdminSite = 'collectionAdminSite',
  AdminPool = 'pool',
  CompressionAdminOperator = 'compressionAdminOperator',
  RecycleAdminOperator = 'recycleAdminOperator',
  EmissionAdminOperator = 'emissionAdminOperator',
  EmissionAdminSite = 'emissionAdminSite',
}

export type AdminPoolMyPageFormData = {
  mail: string;
  tel: string;
};

export type MyPageResponseMapper = {
  [MyPageType.CollectionAdminOperator]: CollectionAdminOperatorMyPage;
  [MyPageType.CollectionUserNormal]: CollectionUserNormalMyPage;
  [MyPageType.CollectionAdminSite]: CollectionAdminSiteMyPage;
  [MyPageType.AdminPool]: AdminPoolMyPage;
  [MyPageType.CompressionAdminOperator]: CompressionRecycleAdminOperatorMyPage;
  [MyPageType.RecycleAdminOperator]: RecycleAdminOperatorMyPage;
  [MyPageType.EmissionAdminOperator]: EmissionAdminOperatorMyPage;
  [MyPageType.EmissionAdminSite]: EmissionAdminSiteMyPage;
};

export type MyPageResponse<T extends keyof MyPageResponseMapper> =
  MyPageResponseMapper[T];

export type MyPageFormDataMapper = {
  [MyPageType.CollectionAdminOperator]: CollectionAdminOperatorMyPageFormData;
  [MyPageType.CollectionUserNormal]: CollectionUserNormalMyPageFormData;
  [MyPageType.CollectionAdminSite]: CollectAdminSiteMyPageFormData;
  [MyPageType.AdminPool]: AdminPoolMyPageFormData;
  [MyPageType.CompressionAdminOperator]: CompressionRecycleAdminOperatorMyPageFormData;
  [MyPageType.RecycleAdminOperator]: RecycleAdminOperatorMyPageFormData;
  [MyPageType.EmissionAdminOperator]: EmissionAdminOperatorMyPageFormData;
  [MyPageType.EmissionAdminSite]: EmissionAdminSiteMyPageFormData;
};

export type MyPageFormData<T extends keyof MyPageFormDataMapper> =
  MyPageFormDataMapper[T];
